import React, { useState } from "react";
import axios from "axios";
import "./CreatePoll.css";

const categories = [
  "Sports",
  "Tech",
  "Politics",
  "Entertainment",
  "Food",
  "Travel",
];

const fonts = [
  "Inter, sans-serif",
  "Roboto, sans-serif",
  "Georgia, serif",
  "Courier New, monospace",
  "Comic Sans MS, cursive",
];

export default function CreatePoll() {
  const [category, setCategory] = useState("");
  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState<string[]>(["", ""]);
  const [primaryColor, setPrimaryColor] = useState("#4f46e5");
  const [secondaryColor, setSecondaryColor] = useState("#e5e7eb");
  const [font, setFont] = useState(fonts[0]);

  const apiBase = (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");

  const handleOptionChange = (index: number, value: string) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };

  const addOption = () => setOptions([...options, ""]);
  const removeOption = (index: number) =>
    setOptions(options.filter((_, i) => i !== index));

  const handleSubmit = async () => {
    try {
      const payload = {
        title: question,
        category,
        primaryColor,
        secondaryColor,
        fontFamily: font,
        options: options
          .filter((opt) => opt.trim() !== "")
          .map((opt) => ({ optionText: opt })),
      };

      console.log("Submitting poll:", payload);

      const token = localStorage.getItem("token");

      const res = await axios.post(`${apiBase}/api/polls`, payload, {
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });

      console.log("Poll created:", res.data);
      alert("Poll created successfully!");
      // Reset form
      setCategory("");
      setQuestion("");
      setOptions(["", ""]);
      setPrimaryColor("#4f46e5");
      setSecondaryColor("#e5e7eb");
      setFont(fonts[0]);
    } catch (err: any) {
      console.error("Poll creation failed", err);
      alert(
        err.response?.data?.message ||
          err.response?.data?.error ||
          "Poll creation failed"
      );
    }
  };

  return (
    <div className="create-poll-container">
      {/* Left side: configuration form */}
      <div className="poll-config">
        <h2>Create a Poll</h2>

        <label>
          Category
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="">Select category</option>
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </label>

        <label>
          Question
          <input
            type="text"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="Enter your poll question"
          />
        </label>

        <div className="options-config">
          <label>Options</label>
          {options.map((opt, i) => (
            <div key={i} className="option-row">
              <input
                type="text"
                value={opt}
                onChange={(e) => handleOptionChange(i, e.target.value)}
                placeholder={`Option ${i + 1}`}
              />
              {options.length > 2 && (
                <button
                  type="button"
                  className="remove-btn"
                  onClick={() => removeOption(i)}
                >
                  ✕
                </button>
              )}
            </div>
          ))}
          <button type="button" className="add-btn" onClick={addOption}>
            + Add Option
          </button>
        </div>

        <div className="style-config">
          <label>
            Primary Color
            <input
              type="color"
              value={primaryColor}
              onChange={(e) => setPrimaryColor(e.target.value)}
            />
          </label>

          <label>
            Secondary Color
            <input
              type="color"
              value={secondaryColor}
              onChange={(e) => setSecondaryColor(e.target.value)}
            />
          </label>

          <label>
            Font
            <select value={font} onChange={(e) => setFont(e.target.value)}>
              {fonts.map((f) => (
                <option key={f} value={f}>
                  {f}
                </option>
              ))}
            </select>
          </label>
        </div>

        <button className="submit-btn" onClick={handleSubmit}>
          Create Poll
        </button>
      </div>

      {/* Right side: live preview */}
      <div className="poll-preview">
        <h3>Preview</h3>
        <div
          className="preview-card"
          style={{
            backgroundColor: secondaryColor,
            borderColor: primaryColor,
            fontFamily: font,
          }}
        >
          <h4 style={{ color: primaryColor }}>{question || "Your question…"}</h4>
          <p className="preview-category">
            {category ? `Category: ${category}` : "No category selected"}
          </p>
          <div className="preview-options">
            {options.map((opt, i) => (
              <button
                key={i}
                className="preview-option"
                style={{ backgroundColor: primaryColor }}
              >
                {opt || `Option ${i + 1}`}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
